import {
  FinancialInstitutionTypes,
  IncomeFrequencyTypes,
  MaritalStatusTypes,
  PreferredSalutationTypes,
} from "@nestoca/multi-tenant";

import {
  AmountFrequencyEnum,
  CreditScoreQualityEnum,
  EmploymentStatusEnum,
  EmploymentTypeEnum,
  IndustriesEnum,
  OperatingAsEnum,
  SalutationsEnEnum,
  SalutationsFrEnum,
  TenureEnum,
  PensionTypeEnum,
  RelationToMainApplicantEnum,
} from "./applicant.enum";
import { MaritalStatusType, PreferredSalutationType } from "./applicant.types";

export const SALUTATION_EN_OPTIONS = [
  {
    value: SalutationsEnEnum.MR,
    label: "form:salutations.mr",
  },
  {
    value: SalutationsEnEnum.MRS,
    label: "form:salutations.mrs",
  },
  {
    value: SalutationsEnEnum.MS,
    label: "form:salutations.ms",
  },
  {
    value: SalutationsEnEnum.MISS,
    label: "form:salutations.miss",
  },
  {
    value: SalutationsEnEnum.DR,
    label: "form:salutations.dr",
  },
  {
    value: SalutationsEnEnum.REV,
    label: "form:salutations.rev",
  },
  {
    value: SalutationsEnEnum.JUDGE,
    label: "form:salutations.judge",
  },
];

export const SALUTATION_FR_OPTIONS = [
  {
    value: SalutationsFrEnum.MR,
    label: "form:salutations.mr",
  },
  {
    value: SalutationsFrEnum.MRS,
    label: "form:salutations.mrs",
  },
  {
    value: SalutationsFrEnum.MS,
    label: "form:salutations.ms",
  },
  {
    value: SalutationsFrEnum.DR,
    label: "form:salutations.dr",
  },
  {
    value: SalutationsFrEnum.REV,
    label: "form:salutations.rev",
  },
  {
    value: SalutationsFrEnum.JUDGE,
    label: "form:salutations.judge",
  },
];

// This one is special since we don't have a 1:1 match on the options
// `MISS` is not a valid option in French
export const SALUTATION_OPTIONS = {
  en: SALUTATION_EN_OPTIONS,
  fr: SALUTATION_FR_OPTIONS,
};

export const PREFERRED_SALUTATION_LABEL: Record<PreferredSalutationType, string> = {
  [PreferredSalutationTypes.MR]: "form:salutations.mr",
  [PreferredSalutationTypes.MS]: "form:salutations.ms",
  [PreferredSalutationTypes.MRS]: "form:salutations.mrs",
  [PreferredSalutationTypes.MISS]: "form:salutations.miss",
  [PreferredSalutationTypes.DR]: "form:salutations.dr",
  [PreferredSalutationTypes.REV]: "form:salutations.rev",
  [PreferredSalutationTypes.JUDGE]: "form:salutations.judge",
  [PreferredSalutationTypes.BISHOP]: "form:salutations.bishop",
  [PreferredSalutationTypes.BRO]: "form:salutations.bro",
  [PreferredSalutationTypes.MAYOR]: "form:salutations.mayor",
  [PreferredSalutationTypes.CANON]: "form:salutations.canon",
  [PreferredSalutationTypes.CAPT]: "form:salutations.capt",
  [PreferredSalutationTypes.CHAPLAIN]: "form:salutations.chaplain",
  [PreferredSalutationTypes.COL]: "form:salutations.col",
  [PreferredSalutationTypes.FR]: "form:salutations.fr",
  [PreferredSalutationTypes.GEN]: "form:salutations.gen",
  [PreferredSalutationTypes.HON]: "form:salutations.hon",
  [PreferredSalutationTypes.LT_COL]: "form:salutations.lt_col",
  [PreferredSalutationTypes.LT]: "form:salutations.lt",
  [PreferredSalutationTypes.MAJ]: "form:salutations.maj",
  [PreferredSalutationTypes.MASTER]: "form:salutations.master",
  [PreferredSalutationTypes.CADET]: "form:salutations.cadet",
  [PreferredSalutationTypes.MSGR]: "form:salutations.msgr",
  [PreferredSalutationTypes.PROF]: "form:salutations.prof",
  [PreferredSalutationTypes.RABBI]: "form:salutations.rabbi",
  [PreferredSalutationTypes.REAR_ADM]: "form:salutations.rear_adm",
  [PreferredSalutationTypes.RT_REV]: "form:salutations.rt_rev",
  [PreferredSalutationTypes.SGT_MAJ]: "form:salutations.sgt_maj",
  [PreferredSalutationTypes.SGT]: "form:salutations.sgt",
  [PreferredSalutationTypes.MSGT]: "form:salutations.msgt",
  [PreferredSalutationTypes.SISTER]: "form:salutations.sister",
  [PreferredSalutationTypes.CWO]: "form:salutations.cwo",
  [PreferredSalutationTypes.REP]: "form:salutations.rep",
  [PreferredSalutationTypes.SEN]: "form:salutations.sen",
  [PreferredSalutationTypes.CMDR]: "form:salutations.cmdr",
  [PreferredSalutationTypes.LT_CMDR]: "form:salutations.lt_cmdr",
  [PreferredSalutationTypes.CPL]: "form:salutations.cpl",
  [PreferredSalutationTypes._1ST_LT]: "form:salutations.1st_lt",
  [PreferredSalutationTypes.CARD]: "form:salutations.card",
  [PreferredSalutationTypes.LADY]: "form:salutations.lady",
  [PreferredSalutationTypes.LORD]: "form:salutations.lord",
  [PreferredSalutationTypes.M_CPL]: "form:salutations.m_cpl",
  [PreferredSalutationTypes.MWO]: "form:salutations.mwo",
  [PreferredSalutationTypes.PASTOR]: "form:salutations.pastor",
  [PreferredSalutationTypes.PTE]: "form:salutations.pte",
  [PreferredSalutationTypes.RT_HON]: "form:salutations.rt_hon",
  [PreferredSalutationTypes._2ND_LT]: "form:salutations.2nd_lt",
  [PreferredSalutationTypes.SIR]: "form:salutations.sir",
  [PreferredSalutationTypes.WO]: "form:salutations.wo",
  [PreferredSalutationTypes.BR_GEN]: "form:salutations.br_gen",
  [PreferredSalutationTypes.CHIEF]: "form:salutations.chief",
  [PreferredSalutationTypes.CHIEF_AD]: "form:salutations.chief_ad",
  [PreferredSalutationTypes.MAJ_ADJ]: "form:salutations.maj_adj",
  [PreferredSalutationTypes.MOTHER]: "form:salutations.mother",
  [PreferredSalutationTypes.ABBE]: "form:salutations.abbe",
  [PreferredSalutationTypes.ADJ]: "form:salutations.adj",
  [PreferredSalutationTypes.MAJ_GEN]: "form:salutations.maj_gen",
  [PreferredSalutationTypes.PRINCE]: "form:salutations.prince",
  [PreferredSalutationTypes.PRINCESS]: "form:salutations.princess",
  [PreferredSalutationTypes.MX]: "form:salutations.mx",
  [PreferredSalutationTypes.IND]: "form:salutations.ind",
  [PreferredSalutationTypes.PNS]: "form:salutations.pns",
}

export const CREDITSCORE_QUALITY_OPTIONS = [
  {
    value: CreditScoreQualityEnum.UNKNOWN,
    label: "form:creditScoreQuality.unknown",
  },
  {
    value: CreditScoreQualityEnum.EXCELLENT,
    label: "form:creditScoreQuality.excellent",
  },
  {
    value: CreditScoreQualityEnum.GOOD,
    label: "form:creditScoreQuality.good",
  },
  {
    value: CreditScoreQualityEnum.FAIR,
    label: "form:creditScoreQuality.fair",
  },
  {
    value: CreditScoreQualityEnum.POOR,
    label: "form:creditScoreQuality.poor",
  },
];

export const MARITAL_STATUSES_LABEL: Record<MaritalStatusType, string> = {
  [MaritalStatusTypes.SINGLE]:"form:maritalStatus.single",
  [MaritalStatusTypes.MARRIED]:"form:maritalStatus.married",
  [MaritalStatusTypes.DIVORCED]:"form:maritalStatus.divorced",
  [MaritalStatusTypes.COMMON_LAW]:"form:maritalStatus.commonLaw",
  [MaritalStatusTypes.WIDOWED]:"form:maritalStatus.widowed",
  [MaritalStatusTypes.SEPARATED]:"form:maritalStatus.separated",
  [MaritalStatusTypes.OTHER]:"form:maritalStatus.other",
}

export const TENURE_OPTIONS = [
  {
    label: "form:tenure.permanent",
    value: TenureEnum.PERMANENT,
  },
  {
    label: "form:tenure.probation",
    value: TenureEnum.ON_PROBATION,
  },
  {
    label: "form:tenure.contract",
    value: TenureEnum.ON_CONTRACT,
  },
];

export const INCOME_TYPES_OPTIONS = [
  {
    label: "form:incomeType.salaried",
    value: "SALARIED",
  },
  {
    label: "form:incomeType.hourly",
    value: "HOURLY",
  },
  {
    label: "form:incomeType.hourlyCommissions",
    value: "HOURLY_COMMISSIONS",
  },
  {
    label: "form:incomeType.commission",
    value: "COMMISSIONS",
  },
  {
    label: "form:incomeType.selfEmployed",
    value: "SELF_EMPLOYED",
  },
  {
    label: "form:incomeType.pension",
    value: "PENSION",
  },
  {
    label: "form:incomeType.noIncome",
    value: "NONE",
  },
];

export const EMPLOYMENT_TYPE_OPTIONS = [
  {
    label: "form:employmentType.fullTime",
    value: EmploymentTypeEnum.FULL_TIME,
  },
  {
    label: "form:employmentType.partTime",
    value: EmploymentTypeEnum.PART_TIME,
  },
  {
    label: "form:employmentType.seasonal",
    value: EmploymentTypeEnum.SEASONAL,
  },
  {
    label: "form:employmentType.other",
    value: EmploymentTypeEnum.OTHER,
  },
];

export const INCOME_FREQUENCY_OPTIONS = [
  {
    label: "form:frequency.annually",
    value: AmountFrequencyEnum.ANNUALLY,
  },
  {
    label: "form:frequency.semiannually",
    value: AmountFrequencyEnum.SEMIANNUALLY,
  },
  {
    label: "form:frequency.monthly",
    value: AmountFrequencyEnum.MONTHLY,
  },
  {
    label: "form:frequency.semi-monthly",
    value: AmountFrequencyEnum.SEMIMONTHLY,
  },
  {
    label: "form:frequency.weekly",
    value: AmountFrequencyEnum.WEEKLY,
  },
  {
    label: "form:frequency.biweekly",
    value: AmountFrequencyEnum.BIWEEKLY,
  },
];

type IncomeFrequencyType =
  (typeof IncomeFrequencyTypes)[keyof typeof IncomeFrequencyTypes];

export const INCOME_FREQUENCY_LABEL: Partial<
  Record<IncomeFrequencyType, string>
> = {
  [IncomeFrequencyTypes.ANNUALLY]: "form:frequency.annually",
  [IncomeFrequencyTypes.SEMIANNUALLY]: "form:frequency.semiannually",
  [IncomeFrequencyTypes.MONTHLY]: "form:frequency.monthly",
  [IncomeFrequencyTypes.SEMIMONTHLY]: "form:frequency.semi-monthly",
  [IncomeFrequencyTypes.BIWEEKLY]: "form:frequency.biweekly",
  [IncomeFrequencyTypes.WEEKLY]: "form:frequency.weekly",
};

export const INDUSTRY_OPTIONS = [
  {
    value: IndustriesEnum.BANK_FINANCE,
    label: "form:industry.bank",
  },
  {
    value: IndustriesEnum.MANUFACTURING,
    label: "form:industry.manufacturing",
  },
  {
    value: IndustriesEnum.GOVERNMENT,
    label: "form:industry.government",
  },
  {
    value: IndustriesEnum.HEALTH,
    label: "form:industry.health",
  },
  {
    value: IndustriesEnum.RETAIL,
    label: "form:industry.retail",
  },
  {
    value: IndustriesEnum.HIGH_TECH,
    label: "form:industry.highTech",
  },
  {
    value: IndustriesEnum.EDUCATION,
    label: "form:industry.education",
  },
  {
    value: IndustriesEnum.LEISURE_ENTERTAINMENT,
    label: "form:industry.leisure",
  },
  {
    value: IndustriesEnum.SERVICES,
    label: "form:industry.services",
  },
  {
    value: IndustriesEnum.TRANSPORTATION,
    label: "form:industry.transportation",
  },
  {
    value: IndustriesEnum.NATURAL_RESOURCES,
    label: "form:industry.naturalResources",
  },
  {
    value: IndustriesEnum.CONSTRUCTION,
    label: "form:industry.construction",
  },
  {
    value: IndustriesEnum.FARMING,
    label: "form:industry.farming",
  },
  {
    value: IndustriesEnum.OTHER,
    label: "form:industry.other",
  },
];

// ⚠️ PLACEHOLDER values — confirm exact MO enum values with BB team (NEXAPP-286)
export const EMPLOYMENT_STATUS_OPTIONS = [
  {
    value: EmploymentStatusEnum.EMPLOYED,
    label: "form:employmentStatus.employed",
  },
  {
    value: EmploymentStatusEnum.RETIRED,
    label: "form:employmentStatus.retired",
  },  
  {
    value: EmploymentStatusEnum.UNEMPLOYED,
    label: "form:employmentStatus.unemployed",
  },

  {
    value: EmploymentStatusEnum.STUDENT,
    label: "form:employmentStatus.student",
  },
];

export const BANKING_INSTITUTION_OPTIONS = [
  {
    value: FinancialInstitutionTypes.BMO,
    label: "applications:financialInstitution.bmo",
  },
  {
    value: FinancialInstitutionTypes.CIBC,
    label: "applications:financialInstitution.cibc",
  },
  {
    value: FinancialInstitutionTypes.DESJARDINS,
    label: "applications:financialInstitution.desjardins",
  },
  {
    value: FinancialInstitutionTypes.HSBC,
    label: "applications:financialInstitution.hsbc",
  },
  {
    value: FinancialInstitutionTypes.IG,
    label: "applications:financialInstitution.ig",
  },
  {
    value: FinancialInstitutionTypes.LAURENTIAN,
    label: "applications:financialInstitution.laurentian",
  },
  {
    value: FinancialInstitutionTypes.NBC,
    label: "applications:financialInstitution.nbc",
  },
  {
    value: FinancialInstitutionTypes.RBC,
    label: "applications:financialInstitution.rbc",
  },
  {
    value: FinancialInstitutionTypes.SCOTIA_BANK,
    label: "applications:financialInstitution.scotia_bank",
  },
  {
    value: FinancialInstitutionTypes.SUNLIFE,
    label: "applications:financialInstitution.sunlife",
  },
  {
    value: FinancialInstitutionTypes.TANGERINE,
    label: "applications:financialInstitution.tangerine",
  },
  {
    value: FinancialInstitutionTypes.TD,
    label: "applications:financialInstitution.td",
  },
  {
    value: FinancialInstitutionTypes.OTHER,
    label: "applications:financialInstitution.other",
  },
];

export const OPERATING_AS_OPTIONS = [
  {
    value: OperatingAsEnum.CORPORATION,
    label: "form:selfEmployed.operatingAs.corporation",
  },
  {
    value: OperatingAsEnum.PARTNERSHIP,
    label: "form:selfEmployed.operatingAs.partnership",
  },
  {
    value: OperatingAsEnum.SOLE_PROPRIETOR,
    label: "form:selfEmployed.operatingAs.soloproprietor",
  },
];

export const PENSION_TYPE_OPTIONS = [
  {
    value: PensionTypeEnum.OLD_AGE_SECURITY,
    label: "form:pension.type.oldAgeSecurity",
  },
  {
    value: PensionTypeEnum.CANADIAN_PENSION_PLAN,
    label: "form:pension.type.canadianPensionPlan",
  },
  {
    value: PensionTypeEnum.EMPLOYER,
    label: "form:pension.type.employerPension",
  },
  {
    value: PensionTypeEnum.OTHER,
    label: "form:pension.type.other",
  },
];

export const RELATIONSHIP_MAIN_APPLICANT_OPTIONS = [
  {
    value: RelationToMainApplicantEnum.SPOUSE,
    label: "form:relationToMainApplicant.spouse",
  },
  {
    value: RelationToMainApplicantEnum.COMMON_LAW,
    label: "form:relationToMainApplicant.commonLaw",
  },
  {
    value: RelationToMainApplicantEnum.RELATED_FAMILY_MEMBER,
    label: "form:relationToMainApplicant.familyMember",
  },
  {
    value: RelationToMainApplicantEnum.PARENT,
    label: "form:relationToMainApplicant.parent",
  },
  {
    value: RelationToMainApplicantEnum.CHILD,
    label: "form:relationToMainApplicant.child",
  },
  {
    value: RelationToMainApplicantEnum.SIBLING,
    label: "form:relationToMainApplicant.sibling",
  },
  {
    value: RelationToMainApplicantEnum.GRAND_PARENT,
    label: "form:relationToMainApplicant.grandparent",
  },
  {
    value: RelationToMainApplicantEnum.GRAND_CHILD,
    label: "form:relationToMainApplicant.grandchild",
  },
  {
    value: RelationToMainApplicantEnum.OTHER,
    label: "form:relationToMainApplicant.other",
  },
];
